import { render } from "./OurProjects.vue?vue&type=template&id=4a8f4d12"
import script from "./OurProjects.vue?vue&type=script&lang=js"
export * from "./OurProjects.vue?vue&type=script&lang=js"

import exportComponent from "/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__